import { SET_RUNNING, CHECK_TOKEN_EXPIRE } from './type'

export const showSpinner = {
    type: SET_RUNNING,
    payload: {
        spinner: true
    }
}

export const hideSpinner = {
    type: SET_RUNNING,
    payload: {
        spinner: false
    }
}

export const checkTokenExpire = {
    type: CHECK_TOKEN_EXPIRE
}

// testFn: (text) => {
//     dispatch({
//         type: 'ADD_TODO',
//         payload: {
//             text
//         }
//     });
// }
